import { Fragment } from "react";
import { t } from "i18next";
import { PlusIcon } from "@heroicons/react/20/solid";

import { faTrashCan } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import ColumnPersonInformationAvatar from "../molecules/ColumnPersonInformationAvatar";
import { InputWithCornerHint } from "../atoms/InputWithCornerHint";
import EllipsesMenuTableStock from "../molecules/EllipsesMenuTableStock";

import { TableLoader } from "../molecules/TableLoader";
import ColumnActions from "../molecules/ColumnActions";
import { Empty } from "./Empty";

type FilialProps = {
  branch_id: number;
  embed: string;
  id: number;
  src: string;
  thumbnail: string;
  title: string;
  youtube_id: string;
};

export type TableListPreRecordedProps = {
  clases: FilialProps[];
  title: string;
  functionButtonCreated: () => void;
  functionButtonEdit: (video: any) => void;
  functionButtonDelete: (id: number) => void;
  isLoading: boolean;
  search: string;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

const TableListPreRecorded: React.FC<TableListPreRecordedProps> = ({
  title,
  clases,
  functionButtonCreated,
  functionButtonEdit,
  functionButtonDelete,
  isLoading,
  search,
  handleChange,
}) => {
  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <div className="sm:flex sm:items-center">
        <div className="sm:flex-auto">
          <h1 className="text-base font-semibold leading-6 text-gray-900">
            {title}
          </h1>
        </div>
        <div className="mt-4 sm:ml-16 sm:mt-0 sm:flex sm:items-center sm:space-x-2"></div>
      </div>
      {/* Divider debajo del texto */}
      <div className="border-b border-gray-300 my-3"></div>
      <div className="sm:flex sm:items-center">
        <div className="sm:flex w-64">
          <InputWithCornerHint
            label={t("general.search")}
            span=""
            id="search"
            name="search"
            type="text"
            placeholder={t("additional-videos.views.title")}
            error={false}
            onChange={handleChange}
          />
        </div>
        <div className="mt-8 sm:ml-auto sm:mt-4 sm:flex sm:items-center sm:space-x-4">
          <div className="sm: mb-5 md:mb-0">
            <button
              onClick={functionButtonCreated}
              type="button"
              className="block rounded-full border-2 border-dashed border-gray-400 p-1 text-gray-400 shadow-sm hover:text-gray-500 focus-visible:outline-none"
            >
              <PlusIcon aria-hidden="true" className="h-5 w-5" />
            </button>
          </div>
        </div>
      </div>
      <div className="border-b border-gray-300 mt-5"></div>
      <div className="flow-root">
        <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full px-3 py-2 align-middle sm:px-6 lg:px-8">
            {isLoading ? (
              <TableLoader columns={3} />
            ) : clases.length === 0 ? (
              <Empty
                onClick={functionButtonCreated}
                texto={t("additional-videos.views.text_list")}
              />
            ) : (
              <Fragment>
                <div className="">
                  <table className="min-w-full divide-y divide-gray-300 h-96 ">
                    <tbody className="divide-y divide-gray-200 bg-white">
                      {clases.map((clase) => (
                        <tr key={clase.id}>
                          <ColumnPersonInformationAvatar
                            name={clase.title}
                            email={""}
                            image={clase.thumbnail}
                            classNameImg="h-28 w-28"
                          />
                          <td className="relative whitespace-nowrap py-5 pl-3 pr-4 text-right text-sm font-medium sm:pr-0">
                            <div className="flex items-center justify-end pr-10">
                              <a
                                onClick={() => functionButtonEdit(clase)}
                                href="#"
                                className="text-primary-600 hover:text-primary-900 mr-4"
                              >
                                {t("general.edit")}
                              </a>
                              <a
                                onClick={() => {
                                  functionButtonDelete(clase.id);
                                }}
                                href="#"
                                className="text-red-600 hover:text-red-900"
                              >
                                <FontAwesomeIcon icon={faTrashCan} />
                              </a>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </Fragment>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TableListPreRecorded;
